import React, { useState } from "react";
import PageHeader from "../components/PageHeader";
import useScrollReveal from "../hooks/useScrollReveal";
import { interviews, portraits } from "../mock";
import {
  Dialog,
  DialogContent,
} from "../components/ui/dialog";
import { Play, Calendar, Radio } from "lucide-react";
import TextToSpeech from "../components/TextToSpeech";

export default function Interviews() {
  useScrollReveal();
  const [active, setActive] = useState(null);

  return (
    <div>
      <PageHeader
        eyebrow="Conversations"
        title="Interviews"
        subtitle="Televised conversations and festival appearances on diplomacy, UN reform, India's global role and a life devoted to public service."
        image={portraits.studio}
      />

      <section className="py-20 bg-[#faf8f4]">
        <div className="max-w-6xl mx-auto px-5 lg:px-8 grid md:grid-cols-3 gap-8">
          {interviews.map((v, i) => (
            <article
              key={v.id}
              className="group bg-white rounded-lg border border-[#eae4d8] overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 reveal"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <button
                onClick={() => setActive(v)}
                className="relative block w-full aspect-video overflow-hidden"
              >
                <img
                  src={`https://img.youtube.com/vi/${v.videoId}/hqdefault.jpg`}
                  alt={v.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute inset-0 bg-[#1a2b4a]/30 group-hover:bg-[#1a2b4a]/45 transition-colors" />
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="w-16 h-16 rounded-full bg-[#b8935a] flex items-center justify-center text-white shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <Play size={26} className="ml-1" fill="currentColor" />
                  </span>
                </span>
              </button>
              <div className="p-6">
                <div className="flex items-center gap-4 text-xs text-[#8a8f9c]">
                  <span className="inline-flex items-center gap-1.5">
                    <Radio size={13} /> {v.outlet}
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <Calendar size={13} /> {v.date}
                  </span>
                </div>
                <h3 className="font-serif text-lg font-semibold text-[#1a2b4a] mt-3 leading-snug">
                  {v.title}
                </h3>
                <p className="mt-3 text-sm text-[#5a6070] leading-relaxed">
                  {v.excerpt}
                </p>
                <div className="mt-4">
                  <TextToSpeech text={`${v.title}. ${v.excerpt}`} compact />
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-3xl bg-[#14203a] border-[#14203a] p-2 md:p-3">
          {active && (
            <div>
              <div className="aspect-video w-full overflow-hidden rounded-md">
                <iframe
                  title={active.title}
                  className="w-full h-full"
                  src={`https://www.youtube.com/embed/${active.videoId}`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <div className="p-4">
                <h3 className="font-serif text-xl font-semibold text-white leading-snug">
                  {active.title}
                </h3>
                <p className="text-xs text-white/50 mt-1">
                  {active.outlet} · {active.date}
                </p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
